export const ads = [
  {
    title: 'Heumilch',
    href: 'mailto:office@heumilch.at?subject=Anmeldung%20Masterclass%20VieVinum',
    desktop: { publicId: 'sites/vievinum-2024/images/heumilch-desktop' },
    mobile: { publicId: 'v2/sites/vievinum-2024/images/heumilch-mobile' },
  },
  {
    title: 'Mondial',
    href: 'https://mondial-reisen.com/de/promotions/Vievinum',
    desktop: { publicId: 'sites/vievinum-2024/images/mondial-desktop' },
    mobile: { publicId: 'sites/vievinum-2024/images/mondial-mobile' },
  },
  {
    title: 'Vinum',
    href: 'https://www.vinum.eu/ch/events/eventkalender/event/show/vievinum-vinum-masterclass-das-ultimative-riesling-duell/',
    desktop: { publicId: 'sites/vievinum-2024/images/vinum-desktop' },
    mobile: { publicId: 'sites/vievinum-2024/images/vinum-mobile' },
  },
  {
    title: 'ACA Center Janu',
    href: 'https://www.fendt-janu.at',
    desktop: { publicId: 'sites/vievinum-2024/images/aca-desktop' },
    mobile: { publicId: 'sites/vievinum-2024/images/aca-mobile' },
  },
  {
    title: 'Raben BEXity',
    href: 'https://austria.raben-group.com/',
    desktop: { publicId: 'sites/vievinum-2024/images/raben-desktop' },
    mobile: { publicId: 'sites/vievinum-2024/images/raben-mobile' },
  },
  {
    title: 'Stölzle',
    href: 'https://stoelzle-lausitz.com/',
    desktop: { publicId: 'sites/vievinum-2024/images/stoelzle-desktop' },
    mobile: { publicId: 'sites/vievinum-2024/images/stoelzle-mobile' },
  },
  {
    title: 'WEIN & CO',
    href: 'https://www.weinco.at',
    desktop: { publicId: 'sites/vievinum-2024/images/weinco-desktop' },
    mobile: { publicId: 'sites/vievinum-2024/images/weinco-mobile' },
  },
  {
    title: 'ÖWI',
    href: 'https://shop.oesterreichwein.at/vievinumabverkauf',
    desktop: { publicId: 'v2/sites/vievinum-2024/images/oewi-desktop' },
    mobile: { publicId: 'sites/vievinum-2024/images/oewi-mobile' },
  },
  {
    title: 'Brauunion',
    href: 'https://biostoff.goesser.at',
    desktop: { publicId: 'sites/vievinum-2024/images/brauunion-desktop' },
    mobile: { publicId: 'sites/vievinum-2024/images/brauunion-mobile' },
  },
  {
    title: 'Austria Glas Recycling',
    href: 'https://www.agr.at/glasrecycling/glasverpackungs-abc',
    desktop: {
      publicId: 'sites/vievinum-2024/images/austria_glas_recycling-desktop',
    },
    mobile: {
      publicId: 'sites/vievinum-2024/images/austria_glas_recycling-mobile',
    },
  },
  {
    title: 'Lavazza',
    href: 'https://www.lavazza.at',
    desktop: { publicId: 'v2/sites/vievinum-2024/images/lavazza-desktop' },
    mobile: { publicId: 'sites/vievinum-2024/images/lavazza-mobile' },
  },
  {
    title: 'Vinaria',
    href: 'https://www.vinaria.at/angebote/vinaria-jahresabo-inklusive-weinguide',
    desktop: { publicId: 'sites/vievinum-2024/images/vinaria-desktop' },
    mobile: { publicId: 'sites/vievinum-2024/images/vinaria-mobile' },
  },
  {
    title: 'Wein.plus',
    href: 'https://www.wein.plus/de',
    desktop: { publicId: 'sites/vievinum-2024/images/weinplus-desktop' },
    mobile: { publicId: 'sites/vievinum-2024/images/weinplus-mobile' },
    mobileHref: 'https://places.wein.plus/de',
  },
  {
    title: 'Österreich Werbung',
    href: 'https://www.austriatourism.com/',
    desktop: {
      publicId: 'sites/vievinum-2024/images/oesterreich_werbung-desktop',
    },
    mobile: {
      publicId: 'sites/vievinum-2024/images/oesterreich_werbung-mobile',
    },
  },
  {
    title: 'Brolli',
    href: 'https://www.brolli.com',
    desktop: { publicId: 'sites/vievinum-2024/images/brolli-desktop' },
    mobile: { publicId: 'sites/vievinum-2024/images/brolli-mobile' },
  },
  {
    title: 'Wolf – Das Mystical',
    href: 'https://www.wolfmystical.at/',
    desktop: { publicId: 'sites/vievinum-2024/images/wolf-desktop' },
    mobile: { publicId: 'sites/vievinum-2024/images/wolf-mobile' },
  },
  {
    title: 'Falstaff',
    href: 'https://www.falstaff.com/at',
    desktop: { publicId: 'sites/vievinum-2024/images/falstaff-desktop' },
    mobile: { publicId: 'sites/vievinum-2024/images/falstaff-mobile' },
  },
  {
    title: 'Schlumberger',
    href: 'https://www.schlumberger.at/de',
    desktop: { publicId: 'sites/vievinum-2024/images/schlumberger-desktop' },
    mobile: { publicId: 'sites/vievinum-2024/images/schlumberger-mobile' },
  },
  {
    title: 'Bottlebooks E-Labels',
    href: 'https://elabels.bottlebooks.me',
    desktop: { publicId: 'sites/vievinum-2024/images/bottlebooks-desktop' },
    mobile: { publicId: 'sites/vievinum-2024/images/bottlebooks-mobile' },
  },
] as const satisfies AdDefinition[];

export type AdDefinition = {
  title: string;
  href: string;
  mobileHref?: string;
  desktop: {
    publicId: string;
  };
  mobile: {
    publicId: string;
  };
};

/**
 * 

Vinum
https://www.vinum.eu/ch/events/eventkalender/event/show/vievinum-vinum-masterclass-das-ultimative-riesling-duell/

Mondial
https://mondial-reisen.com/de/promotions/Vievinum

ACA Center Janu
http://www.fendt-janu.at

Raben BEXity
https://austria.raben-group.com/

Stölzle
https://stoelzle-lausitz.com/

WEIN & CO
www.weinco.at

ÖWI
https://shop.oesterreichwein.at/vievinumabverkauf

Brauunion
https://biostoff.goesser.at

Austria Glas Recycling
https://www.agr.at/glasrecycling/glasverpackungs-abc

Lavazza
www.lavazza.at

Vinaria
https://www.vinaria.at/angebote/vinaria-jahresabo-inklusive-weinguide

Wein.plus
Mobile-Version: https://places.wein.plus/de
Desktop-Version: https://www.wein.plus/de

Österreich Werbung
https://www.austriatourism.com/

ARGE Heumilch
office@heumilch.at
Falls Möglich bitte mit dem Betreff „Anmeldung Masterclass VieVinum“

Brolli
www.brolli.com

Wolf – Das Mystical
https://www.wolfmystical.at/

Falstaff
https://www.falstaff.com/at

Schlumberger
https://www.schlumberger.at/de

 */
